module.exports = __webpack_public_path__ + "static/img/1_2_3.d7910aaf.jpg";